import { getRandomInt } from './helpers';

export default function (id = '', random = false) {
  const options = [
    {
      "id": "ERYCHK",
      "img": "\/themes\/custom\/adagio\/order\/offer-option-default.jpg",
      "title": id + ":Arriv\u00e9e anticip\u00e9e",
      "description": "Besoin de disposer de votre chambre d\u00e8s 10 h le jour de votre arriv\u00e9e ? R\u00e9servez d\u00e8s maintenant cet avantage exclusif pour profiter au maximum de votre s\u00e9jour affaires ou loisirs chez Adagio Aparthotel.",
      "price": "+\u00a339.50 \/ stay",
      "detailsLink": "See details",
      "detailsContent": {
        "amenityName": "Arriv\u00e9e anticip\u00e9e",
        "description": "Besoin de disposer de votre chambre d\u00e8s 10 h le jour de votre arriv\u00e9e ? R\u00e9servez d\u00e8s maintenant cet avantage exclusif pour profiter au maximum de votre s\u00e9jour affaires ou loisirs chez Adagio Aparthotel.",
        "currency_symbol": "\u00a3",
        "rates": {
          "label": "Details per night (GBP)",
          "items": []
        },
        "taxesAndFees": {
          "label": "Taxes and fees",
          "items": {
            "included": {
              "label": "Taxes and fees included in the rate",
              "items": [
                "Taxes sur h\u00e9bergement : 10.0 % (par nuit \/ par chambre)"
              ]
            },
            "notIncluded": {
              "label": "Taxes and fees not included in the rate",
              "items": []
            }
          }
        },
        "salesConditionsOfRate": {
          "label": "Sales conditions of rate",
          "description": [
            "Les conditions de vente de la prestation sont identiques \u00e0 celles du tarif de la chambre."
          ]
        }
      },
      "checkbox": {
        "checked": false,
        "type": "checkbox",
        "defaultValue": false
      },
      "eventTracking": {
        "title": {
          "event": "GAevent",
          "eventCategory": "Booking funnel - Rates",
          "eventAction": "Options - Options added",
          "eventLabel": "ERYCHK"
        }
      }
    },
    {
      "id": "UNIQ1",
      "img": "\/themes\/custom\/adagio\/order\/offer-option-default.jpg",
      "title": id + ":Kit b\u00e9b\u00e9",
      "description": "Lit parapluie, chaise haute, poussette canne et baignoire.",
      "price": "+\u00a315.80 \/ stay",
      "detailsLink": "See details",
      "detailsContent": {
        "amenityName": "Kit b\u00e9b\u00e9",
        "description": "Lit parapluie, chaise haute, poussette canne et baignoire.",
        "currency_symbol": "\u00a3",
        "rates": {
          "label": "Details per night (GBP)",
          "items": [
            {
              "dateIn": "2024-01-08",
              "nights": 1,
              "pricing": 5.25
            },
            {
              "dateIn": "2024-01-09",
              "nights": 1,
              "pricing": 5.25
            },
            {
              "dateIn": "2024-01-10",
              "nights": 1,
              "pricing": 5.25
            },
            {
              "dateIn": "2024-01-11",
              "nights": 1,
              "pricing": 5.25
            }
          ]
        },
        "taxesAndFees": {
          "label": "Taxes and fees",
          "items": {
            "included": {
              "label": "Taxes and fees included in the rate",
              "items": []
            },
            "notIncluded": {
              "label": "Taxes and fees not included in the rate",
              "items": []
            }
          }
        },
        "salesConditionsOfRate": {
          "label": "Sales conditions of rate",
          "description": [
            "Les conditions de vente de la prestation sont identiques \u00e0 celles du tarif de la chambre."
          ]
        }
      },
      "checkbox": {
        "checked": false,
        "type": "checkbox",
        "defaultValue": false
      },
      "eventTracking": {
        "title": {
          "event": "GAevent",
          "eventCategory": "Booking funnel - Rates",
          "eventAction": "Options - Options added",
          "eventLabel": "UNIQ1"
        }
      }
    },
    {
      "id": "IPET",
      "img": "https:\/\/www.ahstatic.com\/photos\/gadg_adipet_00_p_346x260.jpg",
      "title": id + ":Pets allowed\\",
      "description": "Accepted and paying",
      "price": "+\u00a39.03 \/ stay",
      "detailsLink": "See details",
      "detailsContent": {
        "amenityName": "Pets allowed\\",
        "description": "Accepted and paying",
        "currency_symbol": "\u00a3",
        "rates": {
          "label": "Details per night (GBP)",
          "items": [
            {
              "dateIn": "2024-01-08",
              "nights": 1,
              "pricing": 3
            },
            {
              "dateIn": "2024-01-09",
              "nights": 1,
              "pricing": 3
            },
            {
              "dateIn": "2024-01-10",
              "nights": 1,
              "pricing": 3
            },
            {
              "dateIn": "2024-01-11",
              "nights": 1,
              "pricing": 3
            }
          ]
        },
        "taxesAndFees": {
          "label": "Taxes and fees",
          "items": {
            "included": {
              "label": "Taxes and fees included in the rate",
              "items": [
                "Taxes sur h\u00e9bergement : 10.0 % (par nuit \/ par chambre)"
              ]
            },
            "notIncluded": {
              "label": "Taxes and fees not included in the rate",
              "items": []
            }
          }
        },
        "salesConditionsOfRate": {
          "label": "Sales conditions of rate",
          "description": [
            "Les conditions de vente de la prestation sont identiques \u00e0 celles du tarif de la chambre."
          ]
        }
      },
      "checkbox": {
        "checked": false,
        "type": "checkbox",
        "defaultValue": false
      },
      "eventTracking": {
        "title": {
          "event": "GAevent",
          "eventCategory": "Booking funnel - Rates",
          "eventAction": "Options - Options added",
          "eventLabel": "IPET"
        }
      }
    },
    {
      "id": "LATCHK",
      "img": "\/themes\/custom\/adagio\/order\/offer-option-default.jpg",
      "title": id + ":D\u00e9part tardif",
      "description": "Vous souhaitez conserver votre chambre jusqu\u0027\u00e0 16 h le jour de votre d\u00e9part ? R\u00e9servez d\u00e8s maintenant cet avantage exclusif pour profiter au maximum de votre s\u00e9jour affaires ou loisirs chez Adagio Aparthotel.",
      "price": "+\u00a339.50 \/ stay",
      "detailsLink": "See details",
      "detailsContent": {
        "amenityName": "D\u00e9part tardif",
        "description": "Vous souhaitez conserver votre chambre jusqu\u0027\u00e0 16 h le jour de votre d\u00e9part ? R\u00e9servez d\u00e8s maintenant cet avantage exclusif pour profiter au maximum de votre s\u00e9jour affaires ou loisirs chez Adagio Aparthotel.",
        "currency_symbol": "\u00a3",
        "rates": {
          "label": "Details per night (GBP)",
          "items": []
        },
        "taxesAndFees": {
          "label": "Taxes and fees",
          "items": {
            "included": {
              "label": "Taxes and fees included in the rate",
              "items": [
                "Taxes sur h\u00e9bergement : 10.0 % (par nuit \/ par chambre)"
              ]
            },
            "notIncluded": {
              "label": "Taxes and fees not included in the rate",
              "items": []
            }
          }
        },
        "salesConditionsOfRate": {
          "label": "Sales conditions of rate",
          "description": [
            "Prestation vendue pour tout le s\u00e9jour et pour tout l\u0027appartement. L\u0027heure maximum de d\u00e9part est pr\u00e9cis\u00e9e dans le descriptif de la prestation (hors conditions particuli\u00e8res d\u00e9finies pour les porteurs de cartes de fid\u00e9lit\u00e9 et d\u0027abonnement).",
            "Les conditions de vente de la prestation sont identiques \u00e0 celles du tarif de la chambre."
          ]
        }
      },
      "checkbox": {
        "checked": false,
        "type": "checkbox",
        "defaultValue": false
      },
      "eventTracking": {
        "title": {
          "event": "GAevent",
          "eventCategory": "Booking funnel - Rates",
          "eventAction": "Options - Options added",
          "eventLabel": "LATCHK"
        }
      }
    },
    {
      "id": "MBREAK",
      "img": "\/themes\/custom\/adagio\/order\/offer-option-default.jpg",
      "title": id + ":Petit d\u00e9jeuner",
      "description": "Petit-d\u00e9jeuner continental en box \u00e0 emporter.",
      "price": "+\u00a356.87\/per adult\/per stay",
      "detailsLink": "See details",
      "detailsContent": {
        "amenityName": "Petit d\u00e9jeuner",
        "description": "Petit-d\u00e9jeuner continental en box \u00e0 emporter.",
        "currency_symbol": "\u00a3",
        "rates": {
          "label": "Details per night (GBP)",
          "items": [
            {
              "dateIn": "2024-01-08",
              "nights": 1,
              "pricing": 18.9
            },
            {
              "dateIn": "2024-01-09",
              "nights": 1,
              "pricing": 18.9
            },
            {
              "dateIn": "2024-01-10",
              "nights": 1,
              "pricing": 18.9
            },
            {
              "dateIn": "2024-01-11",
              "nights": 1,
              "pricing": 18.9
            }
          ]
        },
        "taxesAndFees": {
          "label": "Taxes and fees",
          "items": {
            "included": {
              "label": "Taxes and fees included in the rate",
              "items": [
                "Taxe pays sur la restauration : 10.0 % (par nuit \/ par chambre)"
              ]
            },
            "notIncluded": {
              "label": "Taxes and fees not included in the rate",
              "items": []
            }
          }
        },
        "salesConditionsOfRate": {
          "label": "Sales conditions of rate",
          "description": [
            "Prestation vendue pour les adultes uniquement et pour toute la dur\u00e9e du s\u00e9jour. La vente des petits-d\u00e9jeuners pour les enfants se fait \u00e0 la r\u00e9sidence. Le petit-d\u00e9jeuner enfant peut \u00eatre offert selon la r\u00e9sidence et en fonction de l\u0027\u00e2ge des enfants. Cet avantage n\u0027est valable que lorsque les adultes de l\u0027appartement prennent le petit-d\u00e9jeuner.",
            "Les conditions de vente de la prestation sont identiques \u00e0 celles du tarif de la chambre."
          ]
        }
      },
      "checkbox": {
        "checked": false,
        "type": "checkbox",
        "defaultValue": false
      },
      "eventTracking": {
        "title": {
          "event": "GAevent",
          "eventCategory": "Booking funnel - Rates",
          "eventAction": "Options - Options added",
          "eventLabel": "MBREAK"
        }
      }
    }
  ];
  const count = getRandomInt(options.length);
  return random ? options.slice(0, count) : options
}
